export default __webpack_public_path__ + "static/media/Jerkin of the Primal Spirit.27b2ff72.jpg";